import { ShakingAnimaiton } from "js/react/components/animation";
import { _ } from "js/vendor";
import React, { Component, createRef } from "react";
import styled from "styled-components";

const StyledIcon = styled.i.attrs(({ hideIcon }) => ({
    style: {
        opacity: hideIcon ? 0 : 1
    }
}))``;

const CicleSvg = styled.circle.attrs(({ hideIcon, holdTime = 500 })=>({ style: {
    strokeDashoffset: hideIcon ? 0 : "",
    transition: hideIcon ? `stroke-dashoffset ${holdTime}ms linear` : "none"
} }))``;

class CircleSvg extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { cx, cy, r, className, hideIcon, holdTime } = this.props;

        return (
            <svg>
                <CicleSvg
                    hideIcon={hideIcon}
                    holdTime={holdTime}
                    cx={cx} cy={cy} r={r}
                    className={className}/>
            </svg>
        );
    }
}

export default class HoldButton extends Component {
  state = {
      isWarning: false,
      isHover: false,
      hideIcon: false
  }
  constructor(props) {
      super(props);

      this.$control = createRef();
      this.$label = createRef();
  }

  onMouseOver = () => {
      this.setState({
          isHover: true
      });
  }

  setWarning = isWarning => {
      this.setState({ isWarning });
  }

  showIcon = visible => {
      this.setState({
          hideIcon: !visible
      });
  }

  onMouseOut = () => {
      if (this.state.isWarning) return;

      this.setState({
          isHover: false
      });
  }

  onMouseDown = () => {
      const clickTime = new Date().getTime();
      const { mousedown, holdTime = 500, callback, holdLabel } = this.props;

      this.showIcon(false);

      if (holdLabel && this.$label) {
          this.$label.current.textContent = holdLabel;
      }

      if (mousedown) {
          mousedown();
      }

      const timeout = setTimeout(() => {
          window.removeEventListener("mouseup", onMouseUp);
          this.showIcon(true);
          clearTimeout(timeout);
          if (callback) {
              callback();
          }
      }, holdTime);

      const onMouseUp = ()=>{
          window.removeEventListener("mouseup", onMouseUp);

          if (new Date().getTime() - clickTime < 175) {
              this.setWarning(true);
          }

          this.showIcon(true);
          clearTimeout(timeout);
      };

      window.addEventListener("mouseup", onMouseUp);
  }

  render() {
      const { isHover, hideIcon, isWarning } = this.state;
      const { icon, label, holdLabel, holdTime = 500, additionalClass } = this.props;
      const labelText = isHover ? holdLabel : label;

      return (
          <div className={`control hold_button ${additionalClass}`}
              onMouseEnter={this.onMouseOver} onMouseLeave={this.onMouseOut} onMouseDown={this.onMouseDown} ref={this.$control}>
              <CircleSvg hideIcon={hideIcon} holdTime={holdTime} cx={15} cy={15} r={10} className="path"/>
              <StyledIcon className="micon" hideIcon={hideIcon}>{icon}</StyledIcon>
              <ShakingAnimaiton shake={hideIcon || isWarning} handleComplete={() => this.setWarning(false)}>
                  {labelText && <label ref={this.$label}>{labelText}</label>}
              </ShakingAnimaiton>
          </div>
      );
  }
}
